import {axios} from "@/utilites/api";
import Config from "@/common/config";

const getSearchInvoice = (parameters) => {
    return axios.post(Config.apiURL + '/invoices/titles/search', parameters)
}

const createdInvoices = (parameters) => {
    return axios.post(Config.apiURL + '/invoices', parameters)
}

const getCurrentInvoice = (parameters) => {
    return axios.get( Config.apiURL + '/invoices/' + parameters.id)
}

const changeCurrentInvoice = (parameters) => {
    return axios.patch( Config.apiURL + '/invoices', parameters)
}

const updateCurrentInvoiceStatus = (parameters) => {
    return axios.patch(Config.apiURL + '/invoices/status/' + parameters.invoiceId, parameters.param)
}

const getInvoiceShared = (parameters) => {
    return axios.get(Config.apiURL + '/invoices/shared', {
        params: {
            link: parameters.link,
            lang: parameters.lang === 'AR' ? 'AR' : 'EN',
        },
    })
}

const createStripeSession = (parameters) => {
    return axios.post(Config.apiURL + '/invoices/payments/stripe/session', parameters)
}

const createTripleaPayment = (parameters) => {
    return axios.post(Config.apiURL + '/invoices/payments/triplea', parameters)
}

const targetEfdInvoice = (parameters) => {
    return axios.patch(Config.apiURL + '/invoices/efd/' + parameters.id, parameters)
}

const getBehalfList = (parameters) => {
    return axios.post(`${Config.apiURL}/invoices/behalf-list?clientId=${parameters.clientId}`, parameters.behalfOf)
}

const getAmountSummariesInvoice = (parameters) => {
    return axios.get(`${Config.apiURL}/invoices/amount-summaries?clientId=${parameters.clientId}`)
}

const deleteCurrentInvoice = (parameters) => {
    return axios.delete(Config.apiURL + '/invoices/' + parameters.id, parameters)
}

// /api/v1/story/invoices/amount-summaries

// ручное удлаение инвойса
// function deletedInvoice() {
//     return axios.delete(Config.apiURL + '/invoices/96')
// }

export default {
    getSearchInvoice,
    createdInvoices,
    getCurrentInvoice,
    changeCurrentInvoice,
    updateCurrentInvoiceStatus,
    getInvoiceShared,
    createStripeSession,
    createTripleaPayment,
    targetEfdInvoice,
    getBehalfList,
    getAmountSummariesInvoice,
    deleteCurrentInvoice
}

// deletedInvoice()
